import React from "react";
import * as S from "./footer-component.style";

import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<S.FooterContainer>
			<S.FooterInnerContainer>
				<S.FooterColumns>
					<S.FooterColumn>
						<h5>Fale Conosco</h5>
						<p>
							<a href="mailto:atendimento@becash.com.br">
								atendimento@becash.com.br
							</a>
						</p>
						<p>
							<a href="tel:+551140200257">(11) 4020-0257</a>
						</p>
					</S.FooterColumn>

					<S.FooterColumn>
						<h5>Serviços</h5>
						<Link to="/provedor-de-contas">Provedor de contas</Link>
						<Link to="/baas">Bank as a Service (BaaS)</Link>
						<Link to="/maquininha">Maquininha (POS)</Link>
					</S.FooterColumn>

					<S.FooterColumn>
						<h5>Be Cash</h5>
						<Link to="/#quem-somos">Quem somos</Link>
						{/* <Link to="/denuncias">Canal de Denúncias</Link> */}
						{/* <Link to="/politica-de-privacidade">Política de Privacidade</Link> */}
					</S.FooterColumn>

					<S.FooterColumn>
						<h5>Atendimento</h5>
						<Link to="/suporte">Suporte</Link>
						<Link to="/faq">FAQ</Link>
					</S.FooterColumn>

					<S.FooterColumn>
						<S.BancoCentralText>
							Instituição de Pagamento regulada pelo
						</S.BancoCentralText>
						<a href="https://www.bcb.gov.br/">
							<StaticImage
								style={{ filter: "grayscale(1) brightness(5)" }}
								width={250}
								src="../../assets/images/bacen-logo.webp"
								alt="Logo Banco Central do Brasil na cor negativa."
							/>
						</a>
						<S.Copyright>
							&copy; {currentYear} Copyright Brasil Cash Instituição de
							Pagamento.
						</S.Copyright>
						<S.Divider />

						<S.SocialIcons>
							<a href="https://linkedin.com" aria-label="LinkedIn">
								<FaLinkedin />
							</a>
							<a href="https://facebook.com" aria-label="Facebook">
								<FaFacebook />
							</a>
							<a href="https://instagram.com" aria-label="Instagram">
								<FaInstagram />
							</a>
						</S.SocialIcons>
					</S.FooterColumn>
				</S.FooterColumns>
			</S.FooterInnerContainer>
		</S.FooterContainer>
	);
};

export default Footer;
